import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Api from "../../../config/Api";
import { Modal } from "react-bootstrap";
import SDRF from "./Components/SDRF";
import { toast } from "react-toastify";
import GifImg from "../../../assets/images/loader.gif";
import { useForm } from "react-hook-form";
import StatusBadge from "./Components/StatusBadge";
import { FiCheckCircle } from "react-icons/fi";
import { FaArrowLeft, FaPrint, FaCheck } from "react-icons/fa";
import ReactToPrint from "react-to-print";
import TooltipWidget from "../../Components/Widget/TooltipWidget";
import { BsFillPencilFill } from "react-icons/bs";
import ModalBox from "../../Components/Widget/ModalBox";

const Application = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const admin = useSelector((state) => JSON.parse(state.authentication.admin));
  const isLoggedIn = useSelector((state) => state.authentication.isAdmin);
  const permissions = isLoggedIn ? admin?.role?.permission : null;

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isFromPostApproval = location?.state?.source === "post-approval";

  const application_id = window.atob(id);

  const [applicationDetail, setApplicationDetail] = useState({
    data: "",
    img_url: "",
    nature_disaster: [],
    damages: [],
    amount: "",
    document_img_url: "",
    verifying_officer: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [applicationDocuments, setApplicationDocuments] = useState([]);
  const [documentModalBox, setDocumentModalBox] = useState(false);
  const [documentUrl, setDocumentUrl] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const [isModalShow, setIsModalShow] = useState(false);
  const [selectedData, setSelectedData] = useState({
    id: "",
    status: "",
  });

  const getTooltipTitle = () => {
    const status = applicationDetail?.data?.status;

    // Admin/Sub-admin can access all statuses
    if (admin?.role?.name === "Admin" || admin?.role?.name === "Sub Admin") {
      if (status == 3) return "Approve/Review/Reject SDRF";
      if (status == 1 || status == 4) return "Verify/Review SDRF";
      if (status == 5) return "Final Approve/Reject SDRF";
      return "Manage SDRF"; // fallback
    }

    // Nodal Officer
    if (permissions?.includes("Nodal Officer") && status == 1 || status == 4) {
      return "Verify/Review SDRF";
    }

    // Relief Officer
    if (permissions?.includes("Relief Officer") && status == 3) {
      return "Approve/Review/Reject SDRF";
    }

    // HOD
    if (permissions?.includes("HOD") && status == 5) {
      return "Final Approve/Reject SDRF";
    }

    return null; // No access
  };

  const canEditApplication = () => {
    const status = String(applicationDetail?.data?.status || "");

    if (status !== "7") {
      return !isFromPostApproval;
    }

    const isAdminRole = admin?.role?.name === "Admin";
    const isReliefOfficer = permissions?.includes("Relief Officer");
    const isHod = permissions?.includes("HOD");

    return !isFromPostApproval && (isAdminRole || isReliefOfficer || isHod);
  };

  const modalClose = () => {
    setIsModalShow(false);
    reset();
    setSelectedData({
      id: "",
      status: "",
    });
  };

  const modalShow = (id, status) => {
    setIsModalShow(true);
    setSelectedData({
      id,
      status,
    });
  };

  const documentModalClose = () => {
    setDocumentModalBox(false);
  };

  const openModal = (data) => () => {
    setDocumentModalBox(true);
    setDocumentUrl(data);
  };

  // get application
  const getApplicationDetail = async (id) => {
    try {
      const body = { id };
      const res = await Api("view_applicant_details", "POST", body);
      if (res.data.status === 1) {
        setApplicationDetail({
          data: res.data.ApplicantDetails.Details,
          img_url: res.data.ApplicantDetails.img_url,
          nature_disaster: res.data.ApplicantDetails.nature_disaster,
          damages: res.data.ApplicantDetails.damages,
          amount: res.data.ApplicantDetails.amount,
          document_img_url: res.data.ApplicantDetails.document_img_url,
          verifying_officer: res.data.ApplicantDetails.verifying_officer,
        });

        if (!!res?.data?.ApplicantDetails?.Details?.documents?.length) {
          setApplicationDocuments(
            res?.data?.ApplicantDetails?.Details?.documents.split(",")
          );
        }

        setIsLoaded(true);
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      toast.error(error.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  useEffect(() => {
    getApplicationDetail(application_id);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!!admin) {
      reset({
        name: admin.full_name,
      });
    }
  }, [reset]);


  let componentRef = useRef();

  // const onSubmit = async (d) => {
  //   try {
  //     setIsLoading(true);
  //     const formData = new FormData();
  //     formData.append("id", selectedData.id);
  //     formData.append("name", d?.name);
  //     formData.append("remark", d?.remark);
  //     formData.append("status", d?.status);
  //     if (d?.document?.length > 0) {
  //       formData.append("document", d?.document[0]);
  //     }

  //     // NEW: current_status field drives the endpoint
  //     let res;
  //     const currentStatus = Number(d?.current_status);

  //     if (currentStatus === 1 || currentStatus == 4) {
  //       // nodal verify
  //       res = await Api("application_verify", "POST", formData);
  //     } else if (currentStatus === 3) {
  //       // relief officer approve
  //       res = await Api("application_approve", "POST", formData);
  //     } else if (currentStatus === 5) {
  //       // HOD final approve
  //       res = await Api("hod_application_approve", "POST", formData);
  //     } else {
  //       // fallback
  //       res = await Api("application_verify", "POST", formData);
  //     }

  //     if (res.data.status === 1) {
  //       toast.success(res.data.message, {
  //         position: toast.POSITION.BOTTOM_RIGHT,
  //       });
  //       reset();
  //       modalClose();
  //       // reload detail so page header badge updates
  //       getApplicationDetail(application_id);
  //       setIsLoading(false);
  //     } else if (res.data.status === 2) {
  //       toast.error(res.data.message, {
  //         position: toast.POSITION.BOTTOM_RIGHT,
  //       });
  //       reset();
  //       modalClose();
  //       setIsLoading(false);
  //     } else {
  //       toast.error(res.data.message, {
  //         position: toast.POSITION.BOTTOM_RIGHT,
  //       });
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     toast.error(error.message, {
  //       position: toast.POSITION.BOTTOM_RIGHT,
  //     });
  //     setIsLoading(false);
  //   }
  // };

  const onSubmit = async (d) => {
  try {
    setIsLoading(true);
    const formData = new FormData();
    // Different approval endpoints expect different identifier keys.
    formData.append("id", selectedData.id);
    formData.append("application_id", selectedData.id);
    formData.append("name", d?.name);
    formData.append("remark", d?.remark);
    formData.append("status", d?.status);

    // always use modal state as source of current status
    const currentStatus = Number(selectedData?.status || d?.current_status);
    formData.append("current_status", currentStatus);

    if (d?.document?.length > 0) {
      formData.append("document", d?.document[0]);
    }

    // append sanction fields for final approve
    if (currentStatus === 5) {
      formData.append(
        "sanction_letter_number",
        d?.sanction_letter_number ? d.sanction_letter_number : ""
      );
      formData.append(
        "sanction_date",
        d?.sanction_date ? d.sanction_date : ""
      );
    }

    let res;

    if (currentStatus === 1 || currentStatus === 4) {
      // nodal verify
      res = await Api("application_verify", "POST", formData);
    } else if (currentStatus === 3) {
      // relief officer approve
      res = await Api("application_approve", "POST", formData);
    } else if (currentStatus === 5) {
      // HOD final approve
      res = await Api("hod_application_approve", "POST", formData);
    } else {
      toast.error("Invalid current status for this action", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setIsLoading(false);
      return;
    }

    if (res.data.status === 1) {
      toast.success(res.data.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      reset();
      modalClose();
      getApplicationDetail(application_id);
      setIsLoading(false);
    } else if (res.data.status === 2) {
      toast.error(res.data.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      reset();
      modalClose();
      setIsLoading(false);
    } else {
      toast.error(res.data.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setIsLoading(false);
    }
  } catch (error) {
    toast.error(error.message, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    setIsLoading(false);
  }
};

  return (
    <>
      <div className="bg-white p-3 rounded p-3 shadow">
        <div>
          <div className={`loaderoverlay ${!isLoaded && "show"}`}>
            <div>
              <img src={GifImg} alt="Loader" />
              <p>Loading...</p>
            </div>
          </div>

          <div className="mb-3">
            <div className="row">
              <div className="col-lg-6">
                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-primary mx-3"
                    onClick={() => navigate(-1)}
                  >
                    <FaArrowLeft /> Back
                  </button>
                  <h5 className="text-dark m-0">Application Detail</h5>
                  {canEditApplication() && (
                    <TooltipWidget title="Edit SDRF">
                      <button
                        className="btn btn-primary btn-sm ms-2"
                        onClick={() =>
                          navigate("/sdrf-1", {
                            state: {
                              id: applicationDetail?.data?.id,
                              isEdit: true,
                            },
                          })
                        }
                      >
                        <BsFillPencilFill />
                      </button>
                    </TooltipWidget>
                  )}

                  {getTooltipTitle() && (
                    <TooltipWidget title={getTooltipTitle()}>
                      <button
                        className="btn btn-success btn-sm ms-2"
                        onClick={() => {
                          modalShow(
                            applicationDetail?.data?.id,
                            Number(applicationDetail?.data?.status)
                          );
                        }}
                      >
                        <FaCheck />
                      </button>
                    </TooltipWidget>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="d-flex gap-3 align-items-center justify-content-end">
                  {/* THIS stays fixed to real app status */}
                  <div>
                    <StatusBadge status={applicationDetail?.data?.status} />
                  </div>

                  <div>
                    <ReactToPrint
                      trigger={() => (
                        <button type="button" className="btn btn-success px-5">
                          <FaPrint /> Print
                        </button>
                      )}
                      content={() => componentRef}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Detail */}
          <div className="table-responsive">
            <div ref={(el) => (componentRef = el)}>
              <SDRF data={applicationDetail} />
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-4 text-center">
            <div className="mb-3">
              <button
                className="btn btn-primary mx-3"
                onClick={() => navigate(-1)}
              >
                <FaArrowLeft /> Back
              </button>
              <ReactToPrint
                trigger={() => (
                  <button type="button" className="btn btn-success px-5">
                    <FaPrint /> Print
                  </button>
                )}
                content={() => componentRef}
              />
              {canEditApplication() && (
                <button
                  className="btn btn-primary mx-3"
                  onClick={() =>
                    navigate("/sdrf-1", {
                      state: {
                        id: applicationDetail?.data?.id,
                        isEdit: true,
                      },
                    })
                  }
                >
                  <BsFillPencilFill /> Edit
                </button>
              )}
            </div>

            {applicationDetail.data.status === "6" && (
              <div className="row g-4 justify-content-center">
                {applicationDocuments?.length > 0 && (
                  <div className="col-lg-12">
                    <div className="alert alert-warning m-0">
                      <h3 className="text-uppercase fs-5  mb-3">Documents</h3>
                      <div className="text-center d-flex gap-3 justify-content-center">
                        {applicationDocuments?.map((data, i) => (
                          <button
                            onClick={openModal(data)}
                            key={i}
                            className="btn btn-primary"
                          >
                            Document {i + 1}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-lg-12">
                  <div className="alert alert-success thankyou_box rounded-4 p-3 m-0">
                    <FiCheckCircle className="fs-1 text-success mb-3" />
                    <h5 className="m-0">The application has been approved!</h5>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal */}
      <ModalBox
        show={isModalShow}
        hide={modalClose}
        title={getTooltipTitle()} // back to static/dynamic based on actual current status+role
      >
        <div className="p-2">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-3">
                <input
                  type="hidden"
                  {...register("current_status")}
                  value={selectedData.status}
                  readOnly
                />
              {/* Name */}
              <div className="col-12">
                <label>
                  Name <span className="text-danger fw-bold">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  {...register("name", { required: true })}
                  disabled={true}
                  value={admin.full_name || ""}
                />
                {errors.name && (
                  <div className="error_line">Name is required</div>
                )}
              </div>

              {/* Remark */}
              <div className="col-12">
                <label>
                  Comment/Remark <span className="text-danger fw-bold">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows={5}
                  {...register("remark", { required: true })}
                ></textarea>
                {errors.remark && (
                  <div className="error_line">Comment/Remark is required</div>
                )}
              </div>

              {/* Sanction Letter & Date for 5 */}
              {selectedData.status == "5" && (
                <>
                  <div className="col-12">
                    <label>Sanction Letter Number</label>
                    <input
                      className="form-control"
                      type="text"
                      {...register("sanction_letter_number")}
                    />
                  </div>
                  <div className="col-12">
                    <label>Sanction Date</label>
                    <input
                      className="form-control"
                      type="date"
                      max={new Date().toISOString().split("T")[0]}
                      {...register("sanction_date", {
                        required: "Sanction Date is required",
                        validate: (value) => {
                          const today = new Date();
                          const selectedDate = new Date(value);
                          today.setHours(0, 0, 0, 0);
                          selectedDate.setHours(0, 0, 0, 0);
                          const formatDate = (date) => {
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(2, "0");
                            const year = date.getFullYear();
                            return `${day}-${month}-${year}`;
                          };
                          return (
                            selectedDate <= today ||
                            `Sanction Date cannot be after ${formatDate(today)}`
                          );
                        },
                      })}
                    />
                    {errors.sanction_date && (
                      <div className="error_line">
                        {errors.sanction_date.message}
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* File */}
              <div className="col-12">
                <label>Upload supporting file (if any)</label>
                <input
                  className="form-control"
                  type="file"
                  {...register("document")}
                />
              </div>

              {/* ACTION SELECT */}
              <div className="col-12">
                <label>
                  Select Action <span className="text-danger fw-bold">*</span>
                </label>
                <select
                  className="form-select"
                  {...register("status", { required: true })}
                >
                  <option value="">Select Action</option>

                  {/* For Verify / Review */}
                  {(selectedData.status == "1" || selectedData.status == "4") && (
                    <>
                      <option value="2">Revert to DPA for Review</option>
                      <option value="3">Verified & Submitted</option>
                      <option value="7">Application Rejected</option>
                    </>
                  )}

                  {/* For Approve */}
                  {selectedData.status == "3" && (
                    <>
                      <option value="4">Nodal Officer Review</option>
                      <option value="5">Approve</option>
                      <option value="7">Reject</option>
                    </>
                  )}

                  {/* For Final Approve */}
                  {selectedData.status == "5" && (
                    <>
                      <option value="6">Final Approve</option>
                      <option value="7">Reject</option>
                    </>
                  )}
                </select>
                {errors.status && (
                  <div className="error_line">Status is required</div>
                )}
              </div>

              {/* Submit */}
              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={isLoading}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </ModalBox>

      {/* DOCUMENT MODAL */}
      <Modal
        size="xl"
        show={documentModalBox}
        onHide={documentModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-dark">Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="document_iframe">
            <iframe
              title="Document"
              src={`${applicationDetail?.document_img_url}${documentUrl}`}
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Application;
